import 'swiper/swiper-bundle.css'
import '../scss/banner.scss'

import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import type { BannerCarrosselAppProps } from "../banner-carrossel.props"
import { Device } from '@/utils/device'
import { BannerCarrosselAutomatico } from './bannerAutomatico/BannerCarrosselAutomatico'
import { BannerCarrosselPadrao } from './bannerPadrao/BannerCarrosselPadrao'
import { slugify } from '@/utils/slugify'

export function BannerCarrossel({
    id,
    listaBanner,
    tituloBanner,
    nroBannersVisiveisBannerDinamico,
    exibePaginacaoBannerDinamico,
    autoPlayBannerDinamico,
    fullBannerDinamico,
    alturaBannerDinamico,
    bannersVisiveisDesktop,
    bannersVisiveisTablet,
    bannersVisiveisMobile,
    bannersVisiveisApp,
    rewindBannerDinamico,
    exibeNomeBannerDinamico,
    exibeValoresSomenteLogado,
    precoPrincipal,
    condicaoParcelamento,
    device,
    width,
    height,
    isFirst
}: Readonly<BannerCarrosselAppProps>) {
    if (!listaBanner || listaBanner.length === 0) return null

    const slidesConfig = {
        [Device.DESKTOP]: bannersVisiveisDesktop,
        [Device.TABLET]: bannersVisiveisTablet,
        [Device.MOBILE]: bannersVisiveisMobile,
        [Device.APP]: bannersVisiveisApp,
    } as Record<number, number | undefined>

    const slidesPerView = slidesConfig[device] ?? nroBannersVisiveisBannerDinamico ?? 1

    let transicao = listaBanner[0]?.transicao ?? "slide"
    if (transicao === "fade" && slidesPerView > 1) transicao = "slide"

    const fullBannerClass = fullBannerDinamico
        ? ` full${alturaBannerDinamico > 0 ? ' height-' + alturaBannerDinamico : ''}`
        : " container"
    const swiperClassName = `swiper swiper-${id} dynamic-banner dynamic-banner-${slidesPerView}${fullBannerClass}`

    return (
        <>
            {tituloBanner && (
                <div className="title-ctn">
                    <h2 className="bg-title">
                        <span dangerouslySetInnerHTML={{ __html: tituloBanner }} />
                    </h2>
                </div>
            )}

            <div className={swiperClassName}>
                <Swiper
                    key={`swiper-${id}`}
                    modules={[Navigation, Pagination, Autoplay, EffectFade]}
                    slidesPerView={slidesPerView}
                    navigation={{
                        nextEl: `.swiper-${id} .swiper-button-next`,
                        prevEl: `.swiper-${id} .swiper-button-prev`,
                    }}
                    pagination={
                        exibePaginacaoBannerDinamico
                            ? { el: `.swiper-${id} .swiper-pagination`, type: "bullets", clickable: true }
                            : undefined
                    }
                    autoplay={
                        autoPlayBannerDinamico
                            ? { delay: Number(autoPlayBannerDinamico), disableOnInteraction: false }
                            : undefined
                    }
                    rewind={rewindBannerDinamico}
                    effect={transicao}
                >
                    {listaBanner.map((banner, idx) => (
                        banner.automatico && banner.valida_estoque) ? (
                            <SwiperSlide
                                key={banner.id}
                                className={`banner-automatico${fullBannerDinamico ? '' : ' not-full'}`}
                            >
                                <BannerCarrosselAutomatico
                                    banner={banner}
                                    width={width}
                                    height={height}
                                    idx={idx}
                                    isFirst={isFirst && idx === 0}
                                    exibeValoresSomenteLogado={exibeValoresSomenteLogado}
                                    precoPrincipal={precoPrincipal}
                                    condicaoParcelamento={condicaoParcelamento}
                                    device={device}
                                />
                            </SwiperSlide>
                        ) : (
                            <SwiperSlide
                                key={banner.id}
                                className={`banner-img banner-promo swiper-slide
                                    ${banner.automatico ? ' banner-automatico' : ''}
                                    ${!fullBannerDinamico && !banner.url && exibeNomeBannerDinamico ? ' column' : ''}`}
                                data-promo-name={banner.nome_promocao}
                                data-promo-id={slugify(banner.nome_promocao)}
                                data-tipo={banner.tipo}
                                data-creative-name={banner.titulo}
                                style={
                                    (fullBannerDinamico && alturaBannerDinamico > 0 && banner.nome)
                                        ? { backgroundImage: `url(${banner.midiaUrl})` }
                                        : {}
                                }
                                title={fullBannerDinamico ? banner.legenda || undefined : undefined}
                            >
                                <BannerCarrosselPadrao
                                    banner={banner}
                                    fullBannerDinamico={fullBannerDinamico}
                                    alturaBannerDinamico={alturaBannerDinamico}
                                    exibeNomeBannerDinamico={exibeNomeBannerDinamico}
                                    exibeValoresSomenteLogado={exibeValoresSomenteLogado}
                                    width={width}
                                    height={height}
                                    idx={idx}
                                    isFirst={isFirst && idx === 0}
                                    device={device}
                                />
                            </SwiperSlide>
                        )
                    )}
                </Swiper>

                {Boolean(exibePaginacaoBannerDinamico) && (
                    <div className={`swiper-pagination ${exibeNomeBannerDinamico ? "visible-name" : ""}`} />
                )}

                <div className="swiper-button-prev"></div>
                <div className="swiper-button-next"></div>
            </div>
        </>
    )
}